<template>
    <div>
        <div id="pieChart">

        </div>
    </div>
</template>

<script>
    import {EleResize} from "@/utils/esresize.js";
    import store from '@/store/index.js';
    import {lang} from "@/utils/language.js";
    import echarts from 'echarts';

    export default {
        name: "PieChart",
        store,
        props: {
            pie_chart_data: {
                type: Object
            },
            changeCount: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                lang: lang,
                stateLang: '',
            }
        },
        mounted() {
            this.setChart();
        },
        methods: {
            drawPieChart(dom, option) {
                let myChart = echarts.init(document.getElementById(dom));
                let resizeDiv = document.getElementById(dom)
                //绘制图表
                myChart.setOption(option);
                let listener = function () {
                    myChart.resize()
                }
                EleResize.on(resizeDiv, listener)
            },
            setChart() {
                let dom = 'pieChart'
                let option = {
                    title: {
                        text: this.pie_chart_data.title,
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}: ({d}%)"
                    },
                    legend: {
                        orient: 'horizontal',
                        bottom: 'bottom',
                        data: this.pie_chart_data.legendData
                    },
                    series: [{
                        type: 'pie',
                        radius: '55%',
                        data: this.pie_chart_data.seriesData
                    }]
                }
                this.drawPieChart(dom, option)
            },
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },

        },
        watch: {
            stateLang: function () {
                this.setChart();
            },
            changeCount: function () {
                this.setChart();
            }
        },

    }
</script>

<style scoped>
    #pieChart {
        width: 100%;
        height: 500px;
    }
</style>
